<script lang="ts">
  // import Button from "$lib/Button.svelte";
  // import storageAvailable from "$lib/utils/storageAvailable";
  // let showBrowserValues = $state(false);
</script>

<!-- {#snippet liveValue(val: string)} -->
<!--   {@const storedValue = storageAvailable("localStorage") && localStorage.getItem(val)} -->
<!--   {#if showBrowserValues} -->
<!--     <code class="block w-fit text-sm px-1 bg-[hsl(0_0_50/.2)]"> -->
<!--       {storedValue || "[ikke lagra]"} -->
<!--     </code> -->
<!--   {/if} -->
<!-- {/snippet} -->

{#snippet tbodyTr(name: string, func: string)}
  <tr>
    <td
      >{name}
      <!-- {@render liveValue(name)} -->
    </td>
    <td>{func} </td>
  </tr>
{/snippet}

<details>
  <summary>
    <strong>Funksjonelle informasjonskapsler.</strong> Hvis du har godtatt cookies for funksjonalitet
    på dette nettstedet brukes det informasjonskapsler av chatten levert av Leaddesk.
  </summary>

  <p>
    Cookies for funksjonalitet på www.ishavskraft.no lagres ikke før du har godtatt
    cookies/informasjonskapsler for «Funksjonelle» på dette nettstedet. Disse lagres når den
    respektive funksjonen er tatt i bruk, med mindre nettleseren din ikke støtter eller godtar det.
    De lagres til du fjerner de i nettleseren.
  </p>

  <p>
    Disse informasjonskapslene brukes av Leaddesks chat når du har godtatt funksjonelle
    informasjonskapsler. De lagres i din nettlesers <code>localStorage</code> til du fjerner dem.
  </p>

  <p>
    Ishavskraft AS tar forbehold om at Leaddesk kan endre informasjonskapslene som brukes og vi
    oppdaterer ved aktuelle endringer. <em
      >Kilden er
      <a
        href="https://support.leaddesk.com/hc/en-us/articles/4420016421906-Does-Chatbot-use-cookies"
        hreflang="en"
        target="_blank">Leaddesk support</a
      ></em
    >.
  </p>

  <table>
    <!-- navn, verdi, beskrivelse -->
    <thead>
      <tr>
        <th>Navn</th>
        <th>Funksjon</th>
      </tr>
    </thead>
    <tbody>
      <!-- closed_at -->
      <!-- Records the timestamp when the widget was closed. Used to determine user inactivity or session termination. -->
      {@render tbodyTr("closed_at", "Tidspunkt for lukket chat")}
      <!-- *connectorId*_chatHistory -->
      <!-- Stores the serialized chat history for a specific connectorId. Enables chat state restoration across page reloads. -->
      {@render tbodyTr("*connectorId*_chatHistory", "Chat historikk")}
      <!-- *connectorId*_last_msg_ts -->
      <!-- Records the timestamp of the last message sent or received in the chat for a specific connectorId. Used to manage token expiration. -->
      {@render tbodyTr("*connectorId*_last_msg_ts", "Tidspunkt for siste beskjed")}
      <!-- *connectorId*_getjenny_timestamp -->
      <!-- Tracks the most recent bot interaction timestamp for a specific connectorId. Used to manage session validity. -->
      {@render tbodyTr("*connectorId*_getjenny_timestamp", "Tidspunkt for siste beskjed")}
      <!-- *connectorId*_conversationToken -->
      <!-- Stores a token representing the current conversation state. Used for maintaining continuity in chat sessions. -->
      {@render tbodyTr("*connectorId*_conversationToken", "Chat token")}
      <!-- *connectorId*_disclaimer_closed -->
      <!-- Flags whether the user has acknowledged or closed a disclaimer popup for a specific connectorId. Prevents repeated displays. -->
      {@render tbodyTr("*connectorId*_disclaimer_closed", "Tidspunkt for siste beskjed")}
      <!-- *connectorId*_getjenny_bot_identifier -->
      <!-- Identifies the bot configuration used in a specific session. Enables chatbot-specific behavior. -->
      {@render tbodyTr("*connectorId*_getjenny_bot_identifier", "Chat token")}
      <!-- *connectorId*_last_unload_timestamp -->
      <!-- Records the timestamp of the last unload event (e.g., closing a tab or refreshing the page) for a specific connectorId. Helps determine session restarts. -->
      {@render tbodyTr("*connectorId*_last_unload_timestamp", "Tidspunkt for siste beskjed")}
    </tbody>
  </table>

  <!-- <p> -->
  <!--   <Button -->
  <!--     class="bg-[hsl(0_0_50/.2)] font-normal" -->
  <!--     onclick={() => (showBrowserValues = !showBrowserValues)} -->
  <!--     >Utvid tabellen med lagrede verdier</Button -->
  <!--   > -->
  <!-- </p> -->
</details>
